import React, { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import { HEADER_MIN_HEIGHT } from "../../../utils/constants";
import { useControlForm } from "../../../features/forms/forms.hook";
import usePermissions from "../../../hooks/usePermissions";

import { IBriefFormWrapper } from "./brief-form-wrapper.props";

export const BriefFormWrapper = (props: IBriefFormWrapper) => {
  const { formErrors, formRef, headerHeight = HEADER_MIN_HEIGHT, showIf = true } = props;

  const form = useControlForm({
    defaultValues: props.defaultValues,
    validationRules: yupResolver(props.validationSchema),
  });

  const { handleSubmit, isDirty, reset } = form;

  const userPermissions = usePermissions();

  useEffect(() => {
    formRef.current = { handleSubmit, isDirty, reset };
  }, [formRef, handleSubmit, isDirty, reset]);

  useEffect(() => {
    formErrors?.fieldErrors?.forEach((field) =>
      form.setError(
        field.fieldName,
        { type: "custom", message: field.errorMessage },
        { shouldFocus: true }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formErrors]);

  if (!showIf) {
    return null;
  }

  return (
    <props.ContentComponent
      attachedFiles={props.attachedFiles || []}
      currentTabValue={props.currentTabValue}
      defaultValues={props.defaultValues}
      forceOpen={props.forceOpen}
      form={form}
      handleTabChange={props.handleTabChange}
      headerHeight={headerHeight}
      isDirty={isDirty}
      ndaData={props.ndaData}
      onDeleteFile={props.onDeleteFile}
      onUploadFile={props.onUploadFile}
      resourceId={props.resourceId}
      shouldChangeTab={props.shouldChangeTab}
      status={props.status}
      template={props.template}
      userPermissions={userPermissions}
    />
  );
};
